import { Box, CircularProgress } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

import { Project } from '@arra/core';
import { User } from '../../../authentication/context/useUser';
import { CoverContentLayout, CoverLayout, Logo, Text } from '../layout';
import { Footer } from './Footer';

import { useTranslation } from 'react-i18next';
import { getProjectTitleWOYear } from '../../context/useProject';

export const Cover = ({ project, user }: { project: Project; user: User }) => {
  const { t } = useTranslation(['project']);
  const projectName = getProjectTitleWOYear(project);
  const finalizedAt =
    project.finalizedAt instanceof Date
      ? project.finalizedAt
      : project.finalizedAt
        ? new Date(project.finalizedAt)
        : null;
  const isProjectFinalized =
    finalizedAt instanceof Date && !Number.isNaN(finalizedAt.getTime());

  return (
    <CoverLayout>
      <CoverContentLayout>
        <Box height="20px"></Box>
        <Box flex={1} display="flex" alignItems="center">
          <Box
            flex={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Logo
              src="/SONAR LOGO COMPLET - filaire pourpre - 2025.png"
              maxWidth="300px"
              maxHeight="200px"
            />
          </Box>
        </Box>
        <Box flex={5} display="flex" flexDirection="column">
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            marginTop={4}
            marginBottom={5}
          >
            <Box
              display="flex"
              alignItems="center"
              width="80%"
              flexDirection="column"
            >
              <Text fontSize="60px" color="var(--PURPLE);" fontWeight="bold">
                {projectName}
              </Text>
              <Text fontSize="50px" color="var(--PURPLE);">
                {project.year}
              </Text>
            </Box>
          </Box>

          <Text fontSize="80px" condensed fontWeight="bold">
            Résultats complets
          </Text>
          <Box height="35px"></Box>
          <Text fontSize="18px" color="var(--PURPLE);" fontWeight="bold">
            Découvrez les impacts détaillés de votre radio ci-dessous
          </Text>

          <Box
            height="1px"
            marginX={5}
            marginY={5}
            sx={{
              background:
                'repeating-linear-gradient(90deg,black 0 10px,white 0 20px)',
            }}
          />
          <Text fontSize="20px">Retrouvez votre plan d'action sur</Text>
          <Box height="30px"></Box>
          <Box display="flex" alignItems="center" justifyContent="center">
            {/* <Box>
              <img src={team} alt="team" height="60px" />
            </Box> */}
            <Box
              bgcolor="var(--VANILLA)"
              paddingX="15px"
              paddingY="5px"
              height="100%"
              borderRadius="15px"
            >
              <Text fontSize="18px" fontWeight="bold">
                <a
                  href={t('project:pdfExport.cover.url')}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('project:pdfExport.cover.displayedLink')}
                </a>
              </Text>
            </Box>
            {/* <Box width="60px"></Box> */}
          </Box>
          <Box height="30px"></Box>
          {isProjectFinalized ? (
            <>
              <Text fontSize="10px">Projet marqué comme terminé</Text>
              <Text fontSize="10px">(complété à {project.completionRate}%)</Text>
            </>
          ) : (
            <>
              <Text fontSize="10px">Votre projet est</Text>
              <Text fontSize="10px">complété à</Text>
            </>
          )}
          <Box height="10px"></Box>
          <Box display="flex" justifyContent="center">
            {/* <Box width="73px"></Box> */}
            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
              {isProjectFinalized ? (
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    backgroundColor: 'var(--VANILLA)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CheckIcon sx={{ fontSize: 62, color: 'black' }} />
                </Box>
              ) : (
                <>
                  <CircularProgress
                    variant="determinate"
                    thickness={7}
                    value={project.completionRate}
                    sx={{ color: 'var(--VANILLA)' }}
                    size={100}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: 'absolute',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Text fontSize="25px" fontWeight="bold">
                      {project.completionRate}%
                    </Text>
                  </Box>
                </>
              )}
            </Box>
            {/* <Box>
              <img src={studio} alt="studio" height="60px" />
            </Box> */}
          </Box>
          <Footer project={project} user={user} withBorder={false} />
        </Box>
      </CoverContentLayout>
    </CoverLayout>
  );
};
